import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateRfpInput,
    ModelSortDirection,
    Rfp,
    UpdateRfpInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class RfpService {
    private amplifyClient = generateClient();

    constructor() {}

    async getRfp(id: string): Promise<Rfp | null> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getRfp,
                    variables: { id }
                })
            ).data.getRfp;
            return data ? (data as Rfp) : null;
        } catch (error) {
            console.error('Error finding Rfp:', error);
            return null;
        }
    }

    async createRfp(input: CreateRfpInput): Promise<Rfp | null> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createRfp,
                    variables: { input }
                })
            ).data.createRfp;
            return data ? (data as Rfp) : null;
        } catch (error) {
            console.error('Error creating Rfp:', error);
            return null;
        }
    }

    async updateRfp(input: UpdateRfpInput): Promise<Rfp | null> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updateRfp,
                    variables: { input }
                })
            ).data.updateRfp;
            return data ? (data as Rfp) : null;
        } catch (error) {
            console.error('Error updating Rfp:', error);
            return null;
        }
    }

    async listAllRfpsByCreatedAt(
        estatus: string,
        sortDirection: ModelSortDirection = ModelSortDirection.DESC,
        pageLimit: number = 20
    ): Promise<Rfp[]> {
        const rfps: Rfp[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.ListRfpsByCreatedAt,
                        variables: {
                            estatus,
                            limit: pageLimit,
                            nextToken,
                            sortDirection
                        }
                    })
                ).data.ListRfpsByCreatedAt;

                if (response?.items) {
                    rfps.push(...(response.items as Rfp[]));
                }
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);

            return rfps;
        } catch (error) {
            console.error('Error listing Rfps:', error);
            return [];
        }
    }
}
